// @flow
// TODO: Dispatch Redux action that all videos are viewed. With timestamp?
import React, { Component } from 'react';
import { cx } from 'react-emotion';
import { connect } from 'react-redux';
import { components } from '@peachjar/components';
import { withRouter } from 'react-router-dom';
import config from '../../../../config';


import VideoModal from '../components/VideoModal';
import StartUsing from '../components/StartUsing';
import { styles } from './SetupStaffTrainingContainer.css';

const {
  Buttons: { ButtonSecondarySmall },
  ModalConsumer,
  Notifications: { NotificationContainer, notifyError },
} = components;

const trainingVideos = [
  {
    screenshot: `${config.REACT_APP_CDN_URL}/images/Thumbnail+Intro+to+PJ.png`,
    src: 'https://www.youtube.com/embed/tV49Rp6_1Ic?rel=0',
    title: 'Introduction to Peachjar',
    name: 'introToPeachjar',
  },
  {
    screenshot: `${config.REACT_APP_CDN_URL}/images/Thumbnail+Features.png`,
    src: 'https://www.youtube.com/embed/mnzlXkc-_Ec?rel=0',
    title: 'Peachjar Features',
    name: 'peachjarFeatures',
  },
  {
    screenshot: `${config.REACT_APP_CDN_URL}/images/Thumbnail+How+to+Upload.png`,
    src: 'https://www.youtube.com/embed/NEJJ4RdGA9g?rel=0',
    title: 'How To Upload a Flyer',
    name: 'howToUploadFlyer',
  },
  {
    screenshot: `${config.REACT_APP_CDN_URL}/images/Thumbnail+AssignUploadingRights.png`,
    src: 'https://www.youtube.com/embed/JJNATqBYp04?rel=0',
    title: 'How to Assign Flyer Uploading Rights to Others',
    name: 'howToAssignUpload',
  },
  {
    screenshot: `${config.REACT_APP_CDN_URL}/images/Thumbnail+AcctCustomizationMyAccount.png`,
    src: 'https://www.youtube.com/embed/4MP8-myrXcM?rel=0',
    title: 'Account Customization - District Managment',
    name: 'accountCustomization',
  },
];

type State = {
  introToPeachjar: boolean,
  peachjarFeatures: boolean,
  howToUploadFlyer: boolean,
  howToAssignUpload: boolean,
  accountCustomization: boolean,
};
type Props = {||};

class SetupStaffTrainingContainer extends Component<Props, State> {
  state = {
    introToPeachjar: false,
    peachjarFeatures: false,
    howToUploadFlyer: false,
    howToAssignUpload: false,
    accountCustomization: false,
  };

  contentViewed = (name: string): void => {
    this.setState({ [name]: true });
  };

  continueToAccount = () => {
    window.location = 'https://peachjar.com/index.php?a=4';
  };

  render() {
    const isButtonEnabled = Object.values(this.state).every(
      item => item === true
    );

    return (
      <ModalConsumer>
        {({ showModal, closeModal }) => (
          <div className={styles.wrapper}>
            <NotificationContainer />
            <div className="container">
              <h1 className={styles.header}>Training</h1>
              <div className={styles.innerWrapper}>
                <div className="row" style={{ paddingTop: '2rem' }}>
                  <div className="col">
                    <div className={styles.lineItem}>1</div>
                  </div>
                  <div className="col-11">
                    <div className="row flex-column">
                      <p className={styles.headline2}>Training Documents</p>
                      <p className={styles.headlineText}>
                        Please review Peachjar&apos;s Guide to Digital Summer
                        Success for tips to ensure your flyer reaches parents
                        most effectively.
                      </p>
                      <a
                        href="https://info.peachjar.com/hubfs/Guide%20to%20Digital%20Flyer%20Success%20for%20Program%20Providers.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <ButtonSecondarySmall style={{ marginLeft: '2px' }}>
                          View Guide
                        </ButtonSecondarySmall>
                      </a>
                    </div>
                  </div>
                </div>

                <div className={cx('row', styles.row)}>
                  <div className="col">
                    <div className={styles.lineItem}>2</div>
                  </div>
                  <div className="col-11">
                    <div className="row flex-column">
                      <p className={styles.headline2}>Training Videos</p>
                      <p className={styles.headlineText}>
                        Please watch all the videos to complete your training.
                      </p>
                      <div className="d-flex flex-row flex-wrap align-content-start">
                        {trainingVideos.map(video => (
                          <div
                            className={styles.item}
                            onClick={() => {
                              showModal(VideoModal, {
                                closeModal,
                                videoTitle: video.title,
                                videoSrc: video.src,
                              });
                              this.contentViewed(video.name);
                            }}
                            key={video.name}
                            data-testid={`videoClick-${video.name}`}
                          >
                            <p className={styles.itemTitle}>{video.title}</p>
                            <img
                              src={video.screenshot}
                              alt={video.title}
                              width="230px"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row" style={{ paddingTop: '5rem' }}>
                  <div
                    className="d-flex flex-row justify-content-between"
                    style={{ width: '100%', padding: '0 4rem' }}
                  >
                    <p style={{ marginTop: '2rem', marginLeft: '1.75rem' }}>
                      Once all training above is complete, you can start
                      exploring the Peachjar platform.
                    </p>

                    <StartUsing
                      continueToAccount={this.continueToAccount}
                      isButtonEnabled={isButtonEnabled}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ModalConsumer>
    );
  }
}

const mapDispatchToProps = (dispatch): ReduxDispatchProps => ({
  onNotifyError: error => {
    dispatch(notifyError(error.message));
  },
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(SetupStaffTrainingContainer)
);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff-training/containers/SetupStaffTrainingContainer.jsx